import { useState } from 'react';

export const Selector = (props) => {
    const { entity, chooser } = props;
    const [show, setShow] = useState(0);
    switch (entity) {
        case 'attraction':
        case 'characters':
        case 'experiment':
        case 'origin':
            if (chooser.length > 0) {
                return (
                    <div className="selector">
                        <div className="slider" onClick={() => { show === 0 ? setShow(1) : setShow(0); }}>
                            <div className="label">{`Selector ${entity}`}</div>
                            <i className="fa fa-bars"></i>
                        </div>
                        <div className={`parent ${show === 1 ? 'show' : 'hide'}`}>
                            {chooser.map((el, i) => {
                                const link_href = `/admin/entity/collection/${entity}/${el.id}`
                                return (
                                    <a className="link" href={link_href} name="Sorter" key={i}>{el.name}</a>
                                )
                            })}
                        </div>
                    </div>
                )
            } else {
                return (<></>);
            }
        default:
            return (<></>);
    }
}